import { render, staticRenderFns } from "./RegionDialog.vue?vue&type=template&id=5e9de624&scoped=true"
import script from "./RegionDialog.vue?vue&type=script&lang=js"
export * from "./RegionDialog.vue?vue&type=script&lang=js"
import style0 from "./RegionDialog.vue?vue&type=style&index=0&id=5e9de624&prod&scoped=true&lang=css"
import style1 from "./RegionDialog.vue?vue&type=style&index=1&id=5e9de624&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9de624",
  null
  
)

export default component.exports